import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./PhilosophySection.css";

const PhilosophySection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Faster parallax effect
  const y = useTransform(scrollYProgress, [0, 1], [0, -200]);

  // Animation variants for text
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section ref={sectionRef} className="philosophy-section">
      <motion.div className="philosophy-background" style={{ y }}></motion.div>
      <div className="philosophy-content-wrapper">
        <div className="philosophy-content-container">
          <motion.div
            className="philosophy-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
          >
            <motion.h2 className="philosophy-title" variants={textVariants}>
              <span className="yellow-gradient-text">Our Philosophy</span>
            </motion.h2>
            <motion.p
              className="philosophy-description"
              variants={textVariants}
            >
              The Physics of Growth Marketing is simply physics. It requires the
              right amount of force applied in the right direction. We strip
              away the guesswork and apply a proven framework of testing,
              learning, and scaling. We don't believe in luck; we believe in
              calculated impact.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
